import * as React from 'react';
import { useState } from 'react';
// @ts-ignore
import { default as Form } from 'components/connectedForm';
import BlurTextField from '../connectedForm/BlurTextField';
import getValue from '../connectedForm/utils/getValue';
import { BlurTextFieldType } from '../connectedForm/BlurTextField/BlurTextField';
import {
  FixedHeaderFooterSection,
  FixedHeaderFooterSectionPropsType,
  TEXT_AREA_STYLES,
} from 'components/modals/FixedHeaderFooterSection';
import SubmitFeatureRequest from 'graphql/mutations/company/SubmitFeatureRequest.graphql';
import { useMutation } from '@apollo/client';
import { useP4ToastController } from '../../views/system/NotificationsArea';
import {
  AlertType,
  ISubmitFeatureRequestMutationResult,
  ISubmitFeatureRequestMutationVariables,
} from '../../graphql/schema/p4types';
import GridUploader from '../connectedForm/GridUploader';
import { useComponentQueryErrorHandling } from '../../utils/parseErrorResponse';
import getClientMutationId from '../../utils/getClientMutationId';

export const ProductFeedbackForm = ({ onClose }: FixedHeaderFooterSectionPropsType) => {
  const [feedback, setFeedback] = useState<string>();
  const [feedbackContext, setFeedbackContext] = useState<string>();
  const { dispatchSimpleToast } = useP4ToastController();
  const [attachments, setAttachments] = useState<any[]>();

  const handleQueryError = useComponentQueryErrorHandling();

  const [submitFeedbackMutation] = useMutation<
    ISubmitFeatureRequestMutationResult,
    ISubmitFeatureRequestMutationVariables
  >(SubmitFeatureRequest, {
    onError: handleQueryError,
  });

  const handleSubmitForm = () => {
    submitFeedbackMutation({
      variables: {
        input: {
          clientMutationId: getClientMutationId(),
          feedbackRequest: {
            feedback: feedback,
            feedbackContext: feedbackContext,
            attachments: attachments,
          },
        },
      },
    }).then((response) => {
      if (!response.errors) {
        dispatchSimpleToast('Feedback Submitted', 'Feedback has successfully been submitted.', AlertType.Success);
        onClose();
      }
    });
  };

  return (
    <FixedHeaderFooterSection title="Product Feedback" onClose={onClose} onConfirm={handleSubmitForm}>
      <Form.Fieldset cols={1}>
        <BlurTextField
          data-testid={'product-feedback-feedback'}
          value={feedback}
          label={'Feedback'}
          placeholder={'What would you like to do?'}
          onBlur={(value: string) => setFeedback(getValue(value))}
          type={BlurTextFieldType.ExpandableTextArea}
          style={TEXT_AREA_STYLES}
          mandatory={true}
        />
        <BlurTextField
          data-testid={'product-feedback-context'}
          value={feedbackContext}
          label={'Context'}
          placeholder={
            'Describe how this would help you (Any context you provide will help us improve the product for you.)'
          }
          onBlur={(value: string) => setFeedbackContext(getValue(value))}
          type={BlurTextFieldType.ExpandableTextArea}
          style={TEXT_AREA_STYLES}
          mandatory={true}
        />
      </Form.Fieldset>
      <Form.Fieldset cols={1} style={{ marginTop: '1em' }}>
        <GridUploader value={attachments} onChange={setAttachments} />
      </Form.Fieldset>
    </FixedHeaderFooterSection>
  );
};
